import { Pagination } from '../../../../models/Pagination';
import { ProductFilter } from '../../../../models/Product';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../../config';
import { browserClient } from '../../../react-query';
import { fetchAllTitlesProducts } from './fetchAllTitlesProducts';

interface ParamTypes {
    filterMap: ProductFilter;
    pagination: Pagination;
    ageCategory?: string;
    shopLanguage: string | undefined;
}

const ALL_TITLES_PRODUCTS_QUERY_KEY = 'allTitlesProducts';

export const useAllTitlesProducts = ({ filterMap, pagination, ageCategory, shopLanguage }: ParamTypes) => {
    const transformedFilterMap = JSON.stringify(filterMap);
    const { data, ...rest } = useQuery(
        [ALL_TITLES_PRODUCTS_QUERY_KEY, { transformedFilterMap, ageCategory, pagination, shopLanguage }],
        () =>
            fetchAllTitlesProducts({
                pagination,
                filterMap: transformedFilterMap,
                ageCategory,
                shopLanguage
            }),
        {
            ...GlobalReactQueryOptions
        }
    );

    const allTitlesProducts = data?.data;

    return {
        ...rest,
        products: {
            count: allTitlesProducts?.totalHits ?? 0,
            list: allTitlesProducts?.hits ?? []
        }
    };
};

export const invalidateAllTitlesProducts = () => {
    return browserClient.invalidateQueries({ queryKey: [ALL_TITLES_PRODUCTS_QUERY_KEY] });
};
